import { Component, OnInit, OnDestroy } from '@angular/core';
import { RecommenderService } from '@fuse/services/recommender/recommender.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RecommenderFormDialogComponent } from './recommender-form/recommender-form.component';

@Component({
    selector: 'recommender-management',
    templateUrl: './recommender-management.component.html',
    styleUrls: ['./recommender-management.component.scss'],
    animations: fuseAnimations
})
export class RecommenderManagementComponent implements OnInit, OnDestroy {

    private _unsubscribeAll: Subject<any>;
    
    dialogRef: any;
    searchInput: FormControl;
    lang = 'sr';

    constructor(
        private _recommenderService: RecommenderService,
        private _translate: TranslateService,
        private _matDialog: MatDialog,
        private _translationLoader: FuseTranslationLoaderService,
    ) {
        this._unsubscribeAll = new Subject();
        this.searchInput = new FormControl('');
    }

    getTranslations(): void {
        this._translationLoader.getLastLang()
        .then(response => {
            this.lang = response['code'];
            this._translationLoader.getTranslations(this.lang, '25');
            console.log(this.lang);
        })
        .catch(err => Promise.reject(err))
        .then(() => {
        }, err => {
        });
    }

    newRecommendation(): void {
        console.log('Add request');

        this.dialogRef = this._matDialog.open(RecommenderFormDialogComponent, {
            panelClass: 'recommendation-form-dialog',
            data: {
                action: 'new',
            }
        });

        this.dialogRef.afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                // do nothing
            });
    }

    ngOnInit(): void {
        // this._requestService.getAllNotifications().subscribe((data) => {
        //     console.log(data);
        // });
        this.getTranslations();
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
